<template>
  <b-dropdown
    ref="dropdown"
    @active-change="
      active => {
        show = active;
      }
    "
  >
    <button class="button" slot="trigger">
      <span>{{$tc('search.device')}}</span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <div class="dropdown-item" style="width: 350px;" v-if="show">

      <form @submit.prevent="onSubmit">

        <b-field
            :label="$tc('device.OS')+' '+$tc('choose')">
            <b-select :placeholder="$tc('device.OS')+' '+$tc('choose')" expanded v-model="filters.onOsSelect">
                <option value="android">Android</option>
                <option value="ios">IOS</option>
            </b-select>
        </b-field>

        <b-field
            :label="$tc('dropdown.stateFilter')">
            <b-select :placeholder="$tc('dropdown.stateFilter')" expanded v-model="filters.onStateSelect">
                <option value="active">Active</option>
                <option value="bot">Bot</option>
                <option value="old-code">Old code</option>
            </b-select>
        </b-field>

        <b-field :label="$tc('os.version')">
            <b-input v-model="filters.appVersion" :placeholder="$tc('os.version')+' '+$tc('input')"></b-input>
        </b-field>

        <br />

        <button class="button is-primary">
          <b-icon icon="magnify"></b-icon>
          <span>{{$tc('search.search')}}</span>
        </button>
      </form>
    </div>
  </b-dropdown>
</template>

<script>
import BaseForm from "../../../../../components/BaseFilterForm";

export default {
  mixins: [BaseForm],
  methods: {
    fresh() {
      return {
        status: null,
        onOsSelect: null,
        appVersion: null,
        onStateSelect: null,
      };
    },
  }
};
</script>
